import { Routes, provideRouter, withViewTransitions } from '@angular/router';
import { provideZoneChangeDetection } from '@angular/core';
import { providePrimeNG } from 'primeng/config';
import { provideFormFactoryConfig } from 'ngx-dynamic-forms-factory';
import { ConfirmationService, MessageService } from 'primeng/api';
import { provideIcons } from '@ng-icons/core';

import { provideHttpClient } from '@angular/common/http';
import { ICONS } from './theme/icons';
import { ToastService } from './services/toast.service';
import {
  MissingTranslationHandler,
  provideTranslateService,
} from '@ngx-translate/core';
import { AppTheme } from './theme/theme';
import { FormFactoryOptions } from './theme/forms-factory';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { CustomMissingTranslationHandler } from './utils/missing-translations-handler';
import { TRANSLATION_CONSTANTS } from './constants/translation';
// import { provideAbilities } from './permissions/abilities';
export interface CoreOptions {
  routes: Routes;
}

export function provideCore({ routes }: CoreOptions) {
  return [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withViewTransitions()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: AppTheme,
        options: {
          darkModeSelector: 'dark',
        },
      },
    }),
    provideTranslateService({
      fallbackLang: TRANSLATION_CONSTANTS.FALLBACK_LANG,
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: CustomMissingTranslationHandler,
      },
    }),
    provideFormFactoryConfig(FormFactoryOptions),
    provideHttpClient(),
    provideIcons(ICONS),
    // provideAbilities(),
    ConfirmationService,
    MessageService,
    ToastService,
  ];
}
